import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineAppsIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M10 13H3a1.0002 1.0002 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1.0001 1.0001 0 0 0 1-1v-7a1.0001 1.0001 0 0 0-1-1Zm-1 7H4v-5h5v5ZM21 2h-7a1 1 0 0 0-1 1v7a1.0001 1.0001 0 0 0 1 1h7a1.0001 1.0001 0 0 0 1-1V3a1.0002 1.0002 0 0 0-1-1Zm-1 7h-5V4h5v5Zm1 4h-7a1.0001 1.0001 0 0 0-1 1v7a1.0001 1.0001 0 0 0 1 1h7a1.0001 1.0001 0 0 0 1-1v-7a1.0001 1.0001 0 0 0-1-1Zm-1 7h-5v-5h5v5ZM10 2H3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1.0001 1.0001 0 0 0 1-1V3a1.0002 1.0002 0 0 0-1-1ZM9 9H4V4h5v5Z"/>
  </SvgIcon>
}

export default LineAppsIcon
